import axios from 'axios';

const Api = axios.create({
	baseURL: `${process.env.VUE_APP_BASE_API_URL}`,
	withCredentials: false,
	headers: {
		'Accept': '*/*',
		'Content-Type': 'multipart/form-data',
		'Accept-Language': 'en'
	}
});

export default Api;
